import { useEffect, useState } from "react";

const GetContact = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await fetch(
          "https://api.nxtamedia.com/api/contactus/get",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch contacts");
console.log("Fetching from:", "https://api.nxtamedia.com/api/contactus/get");

        const data = await response.json();
        console.log("Fetched contacts:", data);

        setContacts(data?.data || []); 
      } catch (err) {
        console.error(err);
        setError("Error fetching contacts");
      } finally {
        setLoading(false);
      }
    };

    fetchContacts();
  }, []);

  return (
    <div className="max-w-7xl mx-auto p-6">
      <h2 className="text-3xl font-bold mb-6 text-white text-center">
        Contact Submissions
      </h2>

      {loading && <p className="text-white text-center">Loading...</p>}
      {error && <p className="text-red-500 text-center">{error}</p>}
      {!loading && !error && contacts.length === 0 && (
        <p className="text-white text-center">No submissions yet.</p>
      )}

      {!loading && contacts.length > 0 && (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-700 rounded-lg bg-background shadow-lg">
            <thead className="bg-gray-800">
              <tr>
                <th className="px-6 py-3 text-left text-sm font-medium text-gray-200 uppercase tracking-wider">
                  ID
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium text-gray-200 uppercase tracking-wider">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium text-gray-200 uppercase tracking-wider">
                  Email
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium text-gray-200 uppercase tracking-wider">
                  Phone
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium text-gray-200 uppercase tracking-wider">
                  Social Handle
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium text-gray-200 uppercase tracking-wider">
                  Service
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium text-gray-200 uppercase tracking-wider">
                  Project Description
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium text-gray-200 uppercase tracking-wider">
                  Budget
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-700">
              {contacts.map((contact, idx) => (
                <tr
                  key={contact.id}
                  className={`${
                    idx % 2 === 0 ? "bg-gray-600" : "bg-gray-700"
                  } hover:bg-gray-600 transition-colors duration-200`}
                >
                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-200">
                    {contact.id}
                  </td>
                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-200">
                    {contact.name}
                  </td>
                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-200">
                    {contact.email}
                  </td>
                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-200">
                    {contact.phone || "-"}
                  </td>
                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-200">
                    {contact.socialHandle || "-"}
                  </td>
                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-200">
                    {contact.service}
                  </td>
                  <td className="px-6 py-3 whitespace-pre-wrap text-sm text-gray-200 max-w-xs">
                    {contact.projectDesc}
                  </td>
                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-200">
                    {contact.budget || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default GetContact;
